import { makeStyles } from "@mui/styles";

import type { Theme } from "src/theme";

export const useAllIconStyles = makeStyles((theme: Theme) => ({
    root: {
        color: theme.palette.primary.main,
    },
}));
